import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PaymentIntent } from './types/Subscriptions';

interface Payload {
  currency: string;
  priceCodes: string[];
  billingCountry?: string;
  customerName?: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<PaymentIntent>(
    'POST',
    `/api/v2/billing/subscriptions/create-pay-intent`,
    {
      data,
    },
  );
